export class AppError implements Error{
    name: string = "AppError";
    message: string;
    stack?: string | undefined;

    constructor(
        message:string
    ){
        this.message = message;
    }

}